// eslint-disable-next-line @typescript-eslint/triple-slash-reference -- ambient global.d.ts has no runtime JS counterpart to import
/// <reference path="./global.d.ts" />
import { DynamicYieldClient } from "./client";
import { functional } from "@jetblue/dotcom-trust-arc";

const DY_RECOMMENDATION_CONTEXT_TYPE_HOMEPAGE = "HOMEPAGE";
const DY_RECOMMENDATION_CONTEXT_TYPE_OTHER = "OTHER";

export const setPageContext = async ({
  currentUrl,
  isHomePage,
  language: lng = "en",
}: {
  currentUrl?: string;
  isHomePage?: boolean;
  language?: string;
}) => {
  await functional();
  if (globalThis.DY) {
    if (isHomePage) {
      globalThis.DY.recommendationContext = {
        lng,
        type: DY_RECOMMENDATION_CONTEXT_TYPE_HOMEPAGE,
      };
    } else if (currentUrl) {
      globalThis.DY.recommendationContext = {
        data: [{ url: currentUrl }],
        lng,
        type: DY_RECOMMENDATION_CONTEXT_TYPE_OTHER,
      };
    }
  }
};

const DY_GLOBAL_KEY = "DY";

const DY_GLOBAL_POLL_MAX_CHECKS = 30;
const DY_GLOBAL_POLL_INTERVAL_MS = 100;

export const init = (language: string) => {
  let dyChecks = 0;
  const dyInterval = setInterval(() => {
    if (Object.hasOwn(globalThis, DY_GLOBAL_KEY)) {
      clearInterval(dyInterval);
      void setPageContext({
        currentUrl: globalThis.location.href,
        isHomePage: globalThis.location.pathname === "/",
        language,
      });
      return;
    }

    dyChecks++;
    if (dyChecks >= DY_GLOBAL_POLL_MAX_CHECKS) {
      clearInterval(dyInterval);
    }
  }, DY_GLOBAL_POLL_INTERVAL_MS);

  return () => {
    clearInterval(dyInterval);
  };
};

const DY_LOGIN_EVENT_NAME = "Login";
const DY_LOGIN_CUID_TYPE = "TrueBlueNumber";
const DY_LOGIN_TYPE = "login-v1";

export const handleLogin = (tbNumber: string) => {
  globalThis.DY?.API("event", {
    name: DY_LOGIN_EVENT_NAME,
    properties: {
      cuid: tbNumber,
      cuidType: DY_LOGIN_CUID_TYPE,
      dyType: DY_LOGIN_TYPE,
    },
  });
};
export { updateDynamicYieldConsent } from "./consent";
export type DynamicYieldProperites = {
  sectionId: string | undefined;
  language: string;
};

const DynamicYield = ({ sectionId, language }: DynamicYieldProperites) => (
  <>
    <link href="https://cdn.dynamicyield.com" rel="preconnect" />
    <link href="https://st.dynamicyield.com" rel="preconnect" />
    <link href="https://rcom.dynamicyield.com" rel="preconnect" />
    <link href="https://cdn.dynamicyield.com" rel="dns-prefetch" />
    <link href="https://st.dynamicyield.com" rel="dns-prefetch" />
    <link href="https://rcom.dynamicyield.com" rel="dns-prefetch" />
    <DynamicYieldClient language={language} sectionId={sectionId} />
  </>
);

export default DynamicYield;
